import { createContext, useContext } from 'react'
import type { MessageEngine } from '@/engine/MessageEngine/MessageEngine'
import type { ChatEngine } from '@/engine/ChatEngine/ChatEngine'
import type { IChatsCache } from '@/services/ChatsCache/ChatsCache'
import type { ILastMessagesCache } from '@/services/LastMessagesCache/LastMessagesCache'
import type { ISpeechToTextService } from '@/services/SpeechToTextService/interfaces'

export interface Engines {
  messageEngine: MessageEngine
  chatEngine: ChatEngine
  chatsCache: IChatsCache
  lastMessagesCache: ILastMessagesCache
  speechToTextService: ISpeechToTextService
}

const EnginesContext = createContext<Engines | null>(null)

export const EnginesProvider = EnginesContext.Provider

export const useEngines = (): Engines => {
  const ctx = useContext(EnginesContext)
  if (!ctx) {
    throw new Error('useEngines must be used within EnginesProvider')
  }
  return ctx
}
